/* global NDEFReader */
// import React from "react";

// function NFCWriter() {
//   const writeNfc = async () => {
//     try {
//       if ("NDEFReader" in window) {
//         const ndef = new NDEFReader();
//         await ndef.write("Hello from React!");
//         alert("Message written to NFC tag.");
//       } else {
//         alert("Web NFC not supported.");
//       }
//     } catch (err) {
//       alert("Error writing to NFC tag: " + err);
//     }
//   };

//   return <button onClick={writeNfc}>Write NFC</button>;
// }

// export default NFCWriter;

// import React from "react";

// function NFCWriter() {
//   const writeNfc = async () => {
//     try {
//       if ("NDEFReader" in window) {
//         const ndef = new NDEFReader();
//         await ndef.write({
//           records: [
//             {
//               recordType: "url",
//               data: "https://mweeb.com/card/f3877648-b89e-43df-92f4-6a2ac6d84eeq",
//             },
//           ],
//         });
//         alert("URL written to NFC tag.");
//       } else {
//         alert("Web NFC not supported.");
//       }
//     } catch (err) {
//       alert("Error writing to NFC tag: " + err);
//     }
//   };

//   return <button onClick={writeNfc}>Write NFC</button>;
// }

// export default NFCWriter;

/* global NDEFReader */
import React, { useEffect, useState } from "react";
import { FaBroadcastTower } from "react-icons/fa";

function NFCWriter({ url }) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const writeNfc = async () => {
    try {
      if ("NDEFReader" in window) {
        const ndef = new NDEFReader();
        await ndef.write({
          records: [
            {
              recordType: "url",
              data: url,
            },
          ],
        });
        setShowSuccessModal(true);
      } else {
        setErrorMessage("Web NFC not supported.");
      }
    } catch (err) {
      setErrorMessage("Error writing to NFC tag: " + err.message);
    }
  };

  useEffect(() => {
    writeNfc(); // auto-trigger NFC write on mount
  }, []);

  return (
    <div className="text-center" style={styles.container}>
      <p style={styles.instruction}>Hold your device near an NFC tag.</p>
      <FaBroadcastTower size={80} style={styles.icon} />

      {/* Success Modal */}
      {showSuccessModal && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalBox}>
            <h4>NFC Tag Written</h4>
            <p>URL was successfully written to the NFC tag.</p>
            <button
              className="btn btn-success"
              onClick={() => setShowSuccessModal(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Error Message */}
      {errorMessage && (
        <div
          style={{ ...styles.modalBox, border: "1px solid red", marginTop: 20 }}
        >
          <p style={{ color: "red" }}>{errorMessage}</p>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 50,
    fontFamily: "Arial, sans-serif",
  },
  icon: {
    margin: "20px 0",
    color: "#555",
  },
  instruction: {
    fontSize: "16px",
    marginBottom: 20,
  },
  modalBackdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalBox: {
    backgroundColor: "white",
    padding: "20px 30px",
    borderRadius: "10px",
    textAlign: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  },
};

export default NFCWriter;
